import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ISitePage } from 'core-components/sitebuilder/models/ISitePage'
import { selectSitePages } from 'core-components/sitebuilder/store/selectors/selectSitePages'
import { setSitePages } from 'core-components/sitebuilder/store/siteBuilderSlice'
import { StorageApi } from 'src/core/classes/services/api/StorageApi'
import { useAppDispatch } from 'src/core/store'

import { KEY_SITEPAGES_LAYOUT_DATA } from '../../components/app/loaders/constants/sitePage'

export const useSitePages = () => {
  const dispatch = useAppDispatch()
  const pages = useSelector(selectSitePages)

  useEffect(() => {
    const loadSitePageLayoutData = (
      sitePages: ISitePage[]
    ): { pagesWithLayout: ISitePage[]; isChanged: boolean } => {
      const cache = StorageApi.get(KEY_SITEPAGES_LAYOUT_DATA) || {}
      let isChanged = false
      const pagesWithLayout = sitePages.map((sitePage) => {
        if (cache) {
          const cacheSettings = cache[sitePage.id]?.layoutSettings || {}
          const cachedLayout = cache[sitePage.id]?.layout

          const isLayoutChange = cachedLayout && cachedLayout !== sitePage.layoutUser
          const isSettingsChange =
            Object.keys(cacheSettings).length &&
            JSON.stringify(cacheSettings) !== JSON.stringify(sitePage.layoutUserSettings)
          if (isLayoutChange || isSettingsChange) {
            isChanged = true

            return {
              ...sitePage,
              layoutUser: cachedLayout || sitePage.layout || 'default',
              layoutUserSettings: cacheSettings,
            }
          }
        }
        return sitePage
      })

      return { pagesWithLayout, isChanged }
    }

    const { pagesWithLayout, isChanged } = loadSitePageLayoutData(pages)

    if (isChanged) {
      dispatch(setSitePages(pagesWithLayout))
    }
  }, [dispatch, pages])
}
